var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", { staticClass: "no-padding", attrs: { id: "content" } }, [
        _c(
          "div",
          {
            staticClass: "banner imagebg-container",
            staticStyle: {
              height: "350px",
              "background-image": "url(/res/images/career/careers-banner.jpg)",
            },
          },
          [
            _c("div", { staticClass: "container" }, [
              _c("h1", { staticClass: "big-caption" }, [
                _vm._v(_vm._s(_vm.bannerline1[_vm.getCurrentLocale]) + " "),
                _c("em", [_vm._v(_vm._s(_vm.now[_vm.getCurrentLocale]))]),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "med-caption yellow-color" }, [
                _vm._v(_vm._s(_vm.bannerline2[_vm.getCurrentLocale]) + " "),
                _c("strong", [_vm._v("SUNDAIR")]),
                _vm._v("."),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "tab-wrapper" }, [
          _c("div", { staticClass: "tab-container container trans-style" }, [
            _c("ul", { staticClass: "tabs no-padding" }, [
              _c("li", [
                _c("a", { attrs: { "data-toggle": "tab", href: "#general" } }, [
                  _c("i", { staticClass: "soap-icon-friends" }),
                  _vm._v(_vm._s(_vm.tabtitle1[_vm.getCurrentLocale])),
                ]),
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  { attrs: { "data-toggle": "tab", href: "#stralsund" } },
                  [
                    _c("i", { staticClass: "soap-icon-friends" }),
                    _vm._v(_vm._s(_vm.tabtitle2[_vm.getCurrentLocale])),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "active" }, [
                _c("a", { attrs: { "data-toggle": "tab", href: "#berlin" } }, [
                  _c("i", { staticClass: "soap-icon-friends" }),
                  _vm._v(_vm._s(_vm.tabtitle3[_vm.getCurrentLocale])),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tab-content" }, [
              _c(
                "div",
                { staticClass: "tab-pane fade", attrs: { id: "general" } },
                [
                  _c("div", { staticClass: "md-section" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-8 col-md-9",
                        attrs: { id: "main" },
                      },
                      [
                        _c("h2", { staticClass: "skin-color" }, [
                          _vm._v(
                            _vm._s(_vm.openpositions[_vm.getCurrentLocale]) +
                              ": " +
                              _vm._s(_vm.tabtitle1[_vm.getCurrentLocale])
                          ),
                        ]),
                        _c("br"),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sidebar col-sm-4 col-md-3" },
                      [
                        _c("sdr-aboutsundair-box"),
                        _vm._v(" "),
                        _c("sdr-contact-box"),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tab-pane fade", attrs: { id: "stralsund" } },
                [
                  _c("div", { staticClass: "md-section" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-8 col-md-9",
                        attrs: { id: "main" },
                      },
                      [
                        _c("h2", { staticClass: "skin-color" }, [
                          _vm._v(
                            _vm._s(_vm.openpositions[_vm.getCurrentLocale]) +
                              ": " +
                              _vm._s(_vm.tabtitle2[_vm.getCurrentLocale])
                          ),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _vm._m(0),
                        _c("br"),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sidebar col-sm-4 col-md-3" },
                      [
                        _c("sdr-aboutsundair-box"),
                        _vm._v(" "),
                        _c("sdr-contact-box"),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-pane fade in active",
                  attrs: { id: "berlin" },
                },
                [
                  _c("div", { staticClass: "md-section" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-8 col-md-9",
                        attrs: { id: "main" },
                      },
                      [
                        _c("h2", { staticClass: "skin-color" }, [
                          _vm._v(
                            _vm._s(_vm.openpositions[_vm.getCurrentLocale]) +
                              ": " +
                              _vm._s(_vm.tabtitle3[_vm.getCurrentLocale])
                          ),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _vm._m(1),
                        _c("br"),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sidebar col-sm-4 col-md-3" },
                      [
                        _c("sdr-aboutsundair-box"),
                        _vm._v(" "),
                        _c("sdr-contact-box"),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("sdr-promobox-sundair-app"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "toggle-container question-list" }, [
      _c("div", { staticClass: "panel style1" }, [
        _c("h4", { staticClass: "panel-title" }, [
          _c(
            "a",
            { attrs: { "data-toggle": "collapse", href: "#tgg2345qq" } },
            [_vm._v("Steuerreferent (m/w/d)")]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "panel-collapse collapse",
            attrs: { id: "tgg2345qq" },
          },
          [
            _c("div", { staticClass: "panel-content" }, [
              _c("p"),
              _c("h3", [_vm._v("AUFGABEN:")]),
              _c("p"),
              _vm._v(" "),
              _c("ul", { staticClass: "check-circle box" }, [
                _c("li", [
                  _vm._v(
                    "Verantwortlich für die Sicherstellung der sach- und termingerechten Erstellung der Monats- und Jahresabschlüsse nach HGB sowie Statistiken"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Erarbeitung, Implementierung und Weiterentwicklung neuer Standards und Strukturen"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Aufbereitung von finanziellen Daten für die Geschäftsleitung (Reporting)"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Identifikation von Entwicklungsmöglichkeiten, Kostenreduzierungen und Systemverbesserungen"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Steuerliche Beratung von Kapital- und Personengesellschaften im Inland"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("Erstellung von Steuererklärungen")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("Verantwortung für die Einhaltung der Tax Compliance"),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Vorbereitung und Mitwirkung bei Prüfungen durch Dritte"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("Mitwirkung bei steuerlichen Sonderprojekten"),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Ermittlung von Strategien zur optimalen Kapitalnutzung"
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p"),
              _c("h3", [_vm._v("IHR PROFIL:")]),
              _c("p"),
              _vm._v(" "),
              _c("ul", { staticClass: "check-circle box" }, [
                _c("li", [
                  _vm._v(
                    "Erfolgreich abgeschlossenes Studium der Wirtschaftswissenschaften, Steuerberaterexamen oder kaufmännische Ausbildung mit entsprechender Weiterbildung"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Kenntnisse im Bereich der Luftfahrt und einschlägige Berufserfahrung wären von Vorteil"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("sichere Rechnungslegungskenntnisse nach HGB"),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Erfahren in der Analyse und Optimierung von Geschäftsprozessen,Strukturen und Organisationen"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("Unternehmerische und analytische Denkweise"),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Selbstständige, ziel- und ergebnisorientierte Arbeitsweise"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Eine ausgesprochene Hands-on-Mentalität sowie eine hohe Ziel- und Umsetzungsorientierung"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Verbindliche und zuverlässige Kommunikation gegenüber Geschäftspartnern und Mitarbeitern"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("Kommunikationssichere Englischkenntnisse ")]),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Sie erwartet ein herausfordernder Arbeitsplatz mit interessanten Möglichkeiten der persönlichen Weiterentwicklung. Sind Sie interessiert?"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Dann senden Sie bitte Ihre aussagekräftige, vollständige Bewerbung im PDF-Format unter Angabe Ihrer Gehaltsvorstellungen und des frühesten Eintrittstermins per E-Mail an:"
                ),
              ]),
              _vm._v(" "),
              _c("p"),
              _c("h2", [_vm._v("KARRIERE@SUNDAIR.COM")]),
              _c("p"),
            ]),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "toggle-container question-list" }, [
      _c("div", { staticClass: "panel style1" }, [
        _c("h4", { staticClass: "panel-title" }, [
          _c(
            "a",
            {
              attrs: {
                "data-toggle": "collapse",
                href: "#tgg2xxxyxz213zzzxxyyyy",
              },
            },
            [_vm._v("Quality Manager (m/w/d)")]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "panel-collapse collapse",
            attrs: { id: "tgg2xxxyxz213zzzxxyyyy" },
          },
          [
            _c("div", { staticClass: "panel-content" }, [
              _c("p"),
              _c("h3", [_vm._v("AUFGABEN:")]),
              _c("p"),
              _vm._v(" "),
              _c("ul", { staticClass: "check-circle box" }, [
                _c("li", [
                  _vm._v("Zusammenarbeit\tmit\tder\tAufsichtsbehörde"),
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("die\tMitarbeiterführung\tim\tFachbereich")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Sicherstellung\tder\tDurchführung\tvon\tPräventions- und\tKorrekturmaßnahmen"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Aufstellung,\tDokumentation,\tEntwicklung\tdes\tFachbereichs\tQuality\tManagement\tin\tÜbereinstimmung\tmit\tden\tbehördlichen\tRegularien"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Organisation\tund\tFührung\tvon\tfachbereichsbezogenen\tProjektplänen\tund\t-dokumentationen"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Aufrechterhaltung\tder\tQualitätspolitik\tund\tdes\tQualitätssystems"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Überprüfung\tdes\tQualitätssystems\tneuer\tDienstleister"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "die\tVerantwortliche\tEntwicklung,\tOrganisation\tund\tFührung\tvon\tfachbereichsbezogenen\tProjektplänen\tund\t-dokumentationen"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Sicherstellung\tder\tQualifikation\tvon\tMitarbeitern,\tdie\tQualitätsinspektionen\toder\tAudits\tdurchführen"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Überwachung\tder\tGültigkeiten\taller\trelevanten\tDokumente"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Veröffentlichung\tvon\tÄnderungen\tqualitätsrelevanter Sachverhalte"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Teilnahme\tund\tMitarbeit\tim\tPlanungs- und\tLeitungsteam\tdes\tUnternehmens"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "die\tSchnittstellenfunktion\tder\tGeschäftsführung\tfür\tMitarbeiter/innen\tsowie\tfür\texterne\tGesprächspartner"
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p"),
              _c("h3", [_vm._v("IHR PROFIL:")]),
              _c("p"),
              _vm._v(" "),
              _c("ul", { staticClass: "check-circle box" }, [
                _c("li", [
                  _vm._v(
                    "abgeschlossene\tBerufsausbildung\tund\tFortbildung\tim\tkaufmännischen\tBereich, Hochschulstudium\tim\tBereich\tCompliance, Qualitätsmanagement, Recht\tin\tder\tLuftfahrt\toder\teiner\tvergleichbaren\tRichtung von\tVorteil"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "5\tJahre\tBerufserfahrung\tin\tder\tLuftfahrt,\tvorzugsweise\tbei\teiner\tFluggesellschaft"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "2\tJahre\teinschlägige Berufs- und\tManagementerfahrung\tin einer\tvergleichbaren\tPosition"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "umfassende\tKenntnisse\tüber\teinschlägige\tBetriebs- und\tInstandhaltungsvorschriften\tder\tEuropäischen\tUnion\tund\tdie\tdamit verbundenen\tVorschriften,\tAnforderungen\tund\tVerfahren,\tsowie\tdie\tBetriebsdokumentation\tdes\tLuftfahrtunternehmens/Unternehmens"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "hohes\tMaß\tan\tVerantwortungs- und\tPflichtbewusstsein"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("hohe\tBelastbarkeit\tin\tStresssituationen"),
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("Durchsetzungsvermögen")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Organisations- und\tImprovisationstalent\tsowie\thohe\tFlexibilität"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Sehr\tgute\tDeutsch- und\tEnglischkenntnisse\tin\tWort\tund\tSchrift"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("sehr\tgute\tMS-Office\tKenntnisse")]),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Sie erwartet ein herausfordernder Arbeitsplatz mit interessanten Möglichkeiten der persönlichen Weiterentwicklung. Sind Sie interessiert?"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Dann senden Sie bitte Ihre aussagekräftige Bewerbung im PDF-Format unter Angabe Ihrer Gehaltsvorstellungen und des frühesten Eintrittstermins per E-Mail an:"
                ),
              ]),
              _vm._v(" "),
              _c("p"),
              _c("h2", [_vm._v("KARRIERE@SUNDAIR.COM")]),
              _c("p"),
            ]),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }